<template>
  <user-scope-selector
    ref="selector"
    tip="选择人员"
    class="user-selector"
    :value="localValue"
    @input="emitVal"
    :users="usersToUse"
    :root-department="rootDepartment"
    :show-department-tab="false"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
  ></user-scope-selector>
</template>

<script>
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getCompanyUsers, getDepartmentTree } from "@/api/userCenter/company"
import { getProjectUsers } from "@/api/project/project"
import { getAppUsers, getSimpleUsers } from "@/api/user"
import { getUser } from "@/utils/user"

export default {
  name: "user-selector",
  components: { UserScopeSelector },
  props: {
    value: [Array, String],
    disabled: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    statusNormal: Boolean,
    singleValueMode: Boolean, // 当选择单条时,是否自动转化value为字符串(默认全是数组)
    providedUsers: Array,
    appId: String,
    projectId: String
  },
  computed: {
    localValue() {
      if (this.singleValueMode && !this.multiple && !this._.isArray(this.value)) {
        return this.value ? [{ type: "user", value: this.value }] : []
      }
      return (this.value || []).map(id => ({
        type: "user",
        value: id
      }))
    },
    usersToUse() {
      let users = this.providedUsers || this.users
      let usersToUse = this.statusNormal ? users.filter(user => !user.companyScope?.gone) : users
      return usersToUse
        .concat(this.additionalUsers.filter(t => !usersToUse.find(u => u.id == t.id)))
        .map(u => {
          if (u.companyScope?.gone === true && !u.name.endsWith("(已停用)")) u.name += "(已停用)"
          return u
        })
    },
    userMap() {
      return this._.keyBy(this.usersToUse, "id")
    }
  },
  data() {
    return {
      users: [],
      rootDepartment: {},
      // 控件自发请求的用户
      additionalUsers: [],
      // 已请求过的ID集合,避免重复请求
      requestedIdSet: new Set(),
      initPromise: null
    }
  },
  created() {
    this.initUsers()
    getDepartmentTree().then(departmentTree => (this.rootDepartment = departmentTree[0]))
    this.$watch(
      function() {
        return {
          a: this.localValue,
          b: this.providedUsers
        }
      },
      async function(newVal, oldVal) {
        await this.initPromise
        let val = (this.localValue || []).map(t => t.value).filter(t => t)
        let additionalUserIds = val.filter(id => id && !this.userMap[id])
        await this.fetchAdditionalUser(additionalUserIds)
        if (newVal.a != oldVal.a) {
          // 只有当值改变时，才 emit select，避免因范围改动频繁刷新表单
          let valToEmit = null
          if (this.singleValueMode) {
            valToEmit = this.userMap[val[0]] || null
          } else {
            valToEmit = val.map(id => this.userMap[id]).filter(t => t)
          }
          this.$emit("select", valToEmit)
        }
      }
    )
  },
  methods: {
    initUsers() {
      let userPromise = null
      if (this.projectId) userPromise = getProjectUsers(this.projectId)
      else if (this.appId) userPromise = getAppUsers({ appId: this.appId })
      else userPromise = getCompanyUsers()
      this.initPromise = userPromise.then(users => (this.users = users))
    },
    async fetchAdditionalUser(userIds) {
      let newUserIds = userIds.filter(userId => !this.requestedIdSet.has(userId))
      if (!newUserIds.length) return
      newUserIds.forEach(userId => this.requestedIdSet.add(userId))

      let reqUserIds = []
      let companyUsers = []
      newUserIds.forEach(id => {
        let user = getUser(id)
        if (user) companyUsers.push(user)
        else reqUserIds.push(id)
      })
      let reqUsers = reqUserIds.length
        ? (await getSimpleUsers(reqUserIds))?.filter(u => u.id.length == 24)
        : []
      this.additionalUsers = this.additionalUsers.concat(companyUsers, reqUsers)
    },
    emitVal(val) {
      val = val || []

      // emit input
      if (this.singleValueMode) {
        this.$emit("input", val[0]?.value || "")
      } else {
        this.$emit(
          "input",
          val.map(obj => obj.value)
        )
      }

      // emit change
      if (this.singleValueMode) {
        this.$emit("change", this.userMap[val[0]?.value] || null)
      } else {
        this.$emit(
          "change",
          val.map(obj => this.userMap[obj.value])
        )
      }
    },
    focus() {
      this.$refs.selector.focus()
    }
  }
}
</script>

<style scoped></style>
